export const withCategory = (file, category) => {
  const next = new File([file], file.name, {
    type: file.type,
    lastModified: file.lastModified
  });
  next.fileId = file.fileId;
  next.category = category;
  if (file.key != null) next.key = file.key;
  return next;
};
